// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ActivityDrawer.css */

.activity-drawer {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #FFFFFF;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  transform: translateY(100%);
  transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  will-change: transform;
}

.activity-drawer-open {
  transform: translateY(0);
}

/* Header with back button */
.activity-drawer-header {
  display: flex;
  align-items: center;
  padding: 20px 40px;
  background-color: #FFFFFF;
  border-bottom: 1px solid #E5E5E5;
  flex-shrink: 0;
}

.activity-drawer-back-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  background-color: transparent;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;
  font-weight: 600;
  font-size: 16px;
  color: #0077C5;
  transition: background-color 0.2s ease;
}

.activity-drawer-back-btn:hover {
  background-color: #F4F4F4;
}

.activity-drawer-back-btn:focus {
  outline: 2px solid #0077C5;
  outline-offset: 2px;
}

.activity-drawer-back-btn svg {
  width: 24px;
  height: 24px;
  color: #0077C5;
}

/* Content area with iframe */
.activity-drawer-content {
  flex: 1;
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
}

.activity-drawer-iframe {
  width: 100%;
  height: 100%;
  border: none;
  display: block;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .activity-drawer-header {
    padding: 16px 24px;
  }

  .activity-drawer-back-btn {
    font-size: 14px;
    padding: 8px 16px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/styles/ActivityDrawer.css"],"names":[],"mappings":"AAAA,uBAAuB;;AAEvB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,yBAAyB;EACzB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,uDAAuD;EACvD,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kFAAkF;EAClF,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,OAAO;EACP,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF","sourcesContent":["/* ActivityDrawer.css */\n\n.activity-drawer {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #FFFFFF;\n  z-index: 1000;\n  display: flex;\n  flex-direction: column;\n  transform: translateY(100%);\n  transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);\n  will-change: transform;\n}\n\n.activity-drawer-open {\n  transform: translateY(0);\n}\n\n/* Header with back button */\n.activity-drawer-header {\n  display: flex;\n  align-items: center;\n  padding: 20px 40px;\n  background-color: #FFFFFF;\n  border-bottom: 1px solid #E5E5E5;\n  flex-shrink: 0;\n}\n\n.activity-drawer-back-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 20px;\n  background-color: transparent;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;\n  font-weight: 600;\n  font-size: 16px;\n  color: #0077C5;\n  transition: background-color 0.2s ease;\n}\n\n.activity-drawer-back-btn:hover {\n  background-color: #F4F4F4;\n}\n\n.activity-drawer-back-btn:focus {\n  outline: 2px solid #0077C5;\n  outline-offset: 2px;\n}\n\n.activity-drawer-back-btn svg {\n  width: 24px;\n  height: 24px;\n  color: #0077C5;\n}\n\n/* Content area with iframe */\n.activity-drawer-content {\n  flex: 1;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  position: relative;\n}\n\n.activity-drawer-iframe {\n  width: 100%;\n  height: 100%;\n  border: none;\n  display: block;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .activity-drawer-header {\n    padding: 16px 24px;\n  }\n\n  .activity-drawer-back-btn {\n    font-size: 14px;\n    padding: 8px 16px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
